import { render, staticRenderFns } from "./ControlSatelliteIndex.vue?vue&type=template&id=756822ac&scoped=true&"
import script from "./ControlSatelliteIndex.vue?vue&type=script&lang=ts&"
export * from "./ControlSatelliteIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756822ac",
  null
  
)

export default component.exports